import { render, staticRenderFns } from "./UploadVideo-ai-v3.vue?vue&type=template&id=b1a3d996&scoped=true"
import script from "./UploadVideo-ai-v3.vue?vue&type=script&lang=ts"
export * from "./UploadVideo-ai-v3.vue?vue&type=script&lang=ts"
import style0 from "./UploadVideo-ai-v3.vue?vue&type=style&index=0&id=b1a3d996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a3d996",
  null
  
)

export default component.exports